import { useMemo, useState } from "react";
import { Input } from "reactstrap";
import { FormattedMessage } from "react-intl";

export default function SearchableCheckList({
  items,
  selectedIds,
  onChange,
  searchPlaceholder,
}) {
  const [search, setSearch] = useState("");

  const visibleItems = useMemo(() => {
    const needle = search.trim().toLowerCase();
    if (needle.length === 0) {
      return items;
    }
    return items.filter(
      (item) =>
        (item.label ?? "").toLowerCase().includes(needle) ||
        (item.sublabel ?? "").toLowerCase().includes(needle),
    );
  }, [items, search]);

  const toggleItem = (id) => {
    onChange(
      selectedIds.includes(id)
        ? selectedIds.filter((selectedId) => selectedId !== id)
        : [...selectedIds, id],
    );
  };

  return (
    <div>
      <Input
        className="mb-2"
        placeholder={searchPlaceholder}
        aria-label={searchPlaceholder}
        value={search}
        onChange={(event) => setSearch(event.target.value)}
      />
      <div className="check-list">
        {visibleItems.length === 0 ? (
          <p className="text-muted p-2 mb-0">
            <FormattedMessage id="NoMatches" />
          </p>
        ) : (
          visibleItems.map((item) => (
            <label className="check-list__item" key={item.id}>
              <Input
                type="checkbox"
                className="mt-0 me-2 flex-shrink-0"
                checked={selectedIds.includes(item.id)}
                onChange={() => toggleItem(item.id)}
              />
              {item.icon ? (
                <div className="check-list__icon">{item.icon}</div>
              ) : (
                ""
              )}
              <span className="check-list__text">
                <span>{item.label}</span>
                {item.sublabel ? (
                  <span className="check-list__sublabel">{item.sublabel}</span>
                ) : (
                  ""
                )}
              </span>
            </label>
          ))
        )}
      </div>
    </div>
  );
}
